import React, { FC } from 'react'
import styles from 'styles/components/template.module.scss'
import { NavButton } from 'components/Button'
import { LargeMenuCard } from 'components/Card'
import { Spacer } from 'components/Utility'

const PushTemplate: FC = () => {
  return (
    <div className={styles.standard}>
      <Spacer size={40} />
      <LargeMenuCard
        description={'お客さまへ、push通知のメッセージを配信します'}
        iconPath={'/icon/white/large_message.svg'}
        title={'メッセージ配信'}
        url={'/admin/push_notification/create'}
      />
      <Spacer size={24} />
      <LargeMenuCard
        description={'送信予約中や、過去配信したメッセージの一覧を表示します'}
        iconPath={'/icon/white/large_message.svg'}
        title={'配信履歴'}
        url={'/admin/push_notification/list'}
      />
      <Spacer size={24} />
      <NavButton label={'トップページに戻る'} iconPath={'/icon/grey/home.svg'} url={'/admin/shops'} />
      <Spacer size={40} />
    </div>
  )
}

export default PushTemplate
